module.exports = function(service) {
	service 
  .factory("getDataService", getDataService);
  getDataService.$inject = ['$resource','API_URL','$rootScope'];
  function getDataService($resource,API_URL,$rootscope) {
   var data = $resource(API_URL+ ":param1/:param2/:param3/:param4", {param1:"@param1", param2:'@param2', param3:'@param3',param4:'@param4'} ,{
      state: "open"
    }, {
      get: {
        method: "GET"
        
      }
    });
  
   return data;
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/getDataService.js
// module id = 605
// module chunks = 0